"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStyles = exports.transformStyle = void 0;
/**
 * 转换单个样式
 * @param key
 * @param value
 */
function transformStyle(key, value) {
    if (key === 'backgroundImage') {
        return "url(".concat(value, ")");
    }
    return value;
}
exports.transformStyle = transformStyle;
/**
 * 转换完整样式对象
 * @param styles
 */
function transformStyles(styles) {
    var _styles = {};
    for (var key in styles) {
        _styles[key] = transformStyle(key, styles[key]);
    }
    return _styles;
}
exports.transformStyles = transformStyles;
exports.default = {
    transformStyle: transformStyle,
    transformStyles: transformStyles,
};
